var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgWalletInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 10.5719 0 5.85786 2.92893 2.92893C5.85786 0 10.5719 0 20 0H24C33.4281 0 38.1421 0 41.0711 2.92893C44 5.85786 44 10.5719 44 20V24C44 33.4281 44 38.1421 41.0711 41.0711C38.1421 44 33.4281 44 24 44H20C10.5719 44 5.85786 44 2.92893 41.0711C0 38.1421 0 33.4281 0 24V20Z",
    fill: "#51C86F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 13.75H29.5C30.1641 13.75 30.75 14.3359 30.75 15C30.75 15.7031 30.1641 16.25 29.5 16.25H15.125C14.7734 16.25 14.5 16.5625 14.5 16.875C14.5 17.2266 14.7734 17.5 15.125 17.5H29.5C30.8672 17.5 32 18.6328 32 20V28.75C32 30.1562 30.8672 31.25 29.5 31.25H14.5C13.0938 31.25 12 30.1562 12 28.75V16.25C12 14.8828 13.0938 13.75 14.5 13.75ZM28.25 23.125C27.5469 23.125 27 23.7109 27 24.375C27 25.0781 27.5469 25.625 28.25 25.625C28.9141 25.625 29.5 25.0781 29.5 24.375C29.5 23.7109 28.9141 23.125 28.25 23.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgWalletInfo);
export default __webpack_public_path__ + "static/media/img_wallet_info.ae8f2928e03072328094510e508e0f4d.svg";
export { ForwardRef as ReactComponent };